function normalizeStatus(status) {
  if (!status) return 'DRAFT';
  return String(status).toUpperCase();
}

function toDisplayText(value, fallback = '-') {
  if (value === null || value === undefined || value === '') return fallback;
  if (typeof value === 'string' || typeof value === 'number') return String(value);

  if (typeof value === 'object') {
    if (value.name) return String(value.name);
    if (value.title) return String(value.title);
    if (value.slug) return String(value.slug);
    if (value.id) return String(value.id);
  }

  return fallback;
}

function toTagText(value) {
  return toDisplayText(value, '').trim();
}

function toCategoryText(value, fallback = '-') {
  if (value === null || value === undefined || value === '') return fallback;
  if (typeof value === 'string' || typeof value === 'number') return String(value);
  if (typeof value === 'object') {
    if (value.name) return String(value.name);
    if (value.title) return String(value.title);
    if (value.slug) return String(value.slug);
  }
  return fallback;
}

export function mapEditorStatusToApi(status) {
  return status === 'publish' ? 'PUBLISHED' : 'DRAFT';
}

export function mapApiStatusToEditor(status) {
  return normalizeStatus(status) === 'PUBLISHED' ? 'publish' : 'draft';
}

export function mapArticleFormToPayload(values, content) {
  const tags = values.tags
    ? values.tags
        .split(',')
        .map((tag) => tag.trim())
        .filter(Boolean)
    : [];

  return {
    title: values.title?.trim(),
    excerpt: values.excerpt?.trim(),
    content,
    contentType: 'HTML',
    featuredImageUrl: values.featuredImage?.trim() || undefined,
    status: mapEditorStatusToApi(values.status),
    authorName: values.author?.trim(),
    authorEmail: values.authorEmail?.trim() || undefined,
    category: values.category,
    tags,
  };
}

function formatArticleDate(rawDate) {
  if (!rawDate) return '-';
  const parsedDate = new Date(rawDate);
  if (Number.isNaN(parsedDate.getTime())) return '-';
  return parsedDate.toLocaleDateString();
}

function mapApiStatusToUi(status) {
  const normalized = normalizeStatus(status);
  if (normalized === 'PUBLISHED') {
    return { label: 'Published', tone: 'success' };
  }
  if (normalized === 'ARCHIVED') {
    return { label: 'Archived', tone: 'default' };
  }
  return { label: 'Draft', tone: 'warning' };
}

export function mapApiArticleToCard(article) {
  const uiStatus = mapApiStatusToUi(article?.status);
  const normalizedTags = Array.isArray(article?.tags)
    ? article.tags.map(toTagText).filter(Boolean)
    : [];
  const backendId = article?.id || article?._id || '';
  const slug = article?.slug || '';
  const sortAt = article?.publishedAt || article?.updatedAt || article?.createdAt || '';

  return {
    id:
      backendId ||
      slug ||
      `${article?.title || 'article'}-${article?.createdAt || article?.updatedAt || 'unknown'}`,
    backendId,
    slug,
    deleteIdentifier: backendId || slug,
    title: toDisplayText(article?.title, 'Untitled'),
    description: toDisplayText(article?.excerpt, ''),
    author: toDisplayText(article?.authorName || article?.author, 'Unknown'),
    date: formatArticleDate(article?.publishedAt || article?.updatedAt || article?.createdAt),
    sortAt,
    category: toCategoryText(article?.categoryName || article?.category || article?.categorySlug, '-'),
    status: uiStatus.label,
    statusTone: uiStatus.tone,
    content: article?.content || '',
    icon: 'ellipsis',
    image: article?.featuredImageUrl || 'https://placehold.co/1200x600?text=No+Image',
    tags: normalizedTags,
  };
}

export function mapApiArticleToForm(article) {
  const authorName = toDisplayText(article?.authorName || article?.author, '');
  const authorEmail =
    toDisplayText(article?.authorEmail, '') ||
    toDisplayText(article?.author?.email, '') ||
    toDisplayText(article?.author?.contactEmail, '');
  const category = toCategoryText(article?.categoryName || article?.category || article?.categorySlug, '');
  const normalizedTags = Array.isArray(article?.tags)
    ? article.tags.map(toTagText).filter(Boolean).join(', ')
    : '';

  return {
    title: article?.title || '',
    excerpt: article?.excerpt || '',
    author: authorName,
    authorEmail,
    category,
    featuredImage: article?.featuredImageUrl || '',
    status: mapApiStatusToEditor(article?.status),
    tags: normalizedTags,
    content: article?.content || '',
  };
}
